@let card = data();

<pai-anchor-card
  [image]="card.image"
  [imageOptions]="imageOptions"
  alignment="center"
  [title]="card.title"
  [target]="card.file?.url"
  ctaKey="CardNewsletter.View"
  ctaIcon="open_in_new"
/>
